import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TaskFormTemplate } from '@/templates/BossBaby';
import { useBossBabyTasks, useBossBabyTaskDetail } from '@/hooks/useBossBaby';
import { UpdateBossBabyTaskDto } from '@/dto/BossBabyDto';
import { Container } from '@mui/material';

export const TaskEdit: React.FC = () => {
  const navigate = useNavigate();
  const { taskId } = useParams<{ taskId: string }>();

  const { updateTask } = useBossBabyTasks();
  const { task, loading, fetchTask } = useBossBabyTaskDetail(taskId || '');

  useEffect(() => {
    if (taskId) {
      fetchTask();
    }
  }, [taskId, fetchTask]);

  const handleSubmit = async (data: UpdateBossBabyTaskDto) => {
    if (!taskId) return;

    try {
      await updateTask(Number(taskId), data);
    } catch (error) {
      console.error('Update task error:', error);
    }
  };

  const handleCancel = () => {
    navigate('/boss-baby/tasks');
  };

  if (!taskId) {
    return null;
  }

  return (
    <Container>
      <TaskFormTemplate
        initialData={task || undefined}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isEdit={true}
        loading={loading}
      />
    </Container>
  );
};